module.exports = __webpack_public_path__ + "media/images/logo_white-ca0ed538b28e2bce339a334d263426e7.svg";